import { createSelector } from 'reselect';

const stateSelector = state => state.atg__jokerwiz;

const mathBetStateSelector = createSelector(
  stateSelector,
  state => state.mathBet,
);

const settingsStateSelector = createSelector(
  stateSelector,
  state => state.settings,
);

// math bet

export const isLoading = createSelector(
  mathBetStateSelector,
  state => state.loading,
);

export const getCreateBetId = createSelector(mathBetStateSelector, state =>
  state.data != null ? state.data.id : undefined,
);

export const getError = createSelector(
  mathBetStateSelector,
  state => state.error,
);

// settings

export const getSettings = createSelector(
  settingsStateSelector,
  state => state.data,
);

export const isSettingsLoading = createSelector(
  settingsStateSelector,
  state => state.loading,
);

export const getSettingsError = createSelector(
  settingsStateSelector,
  state => state.error,
);
